import script from "./ClientManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientManager.vue?vue&type=script&setup=true&lang=js"

import "./ClientManager.vue?vue&type=style&index=0&id=c3ad2e9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ad2e9a"]])

export default __exports__